import { ApiResponse } from '@shared/models';
import { StockHistoryEntry } from './stock-history-entry';
import { StockHistoryEntryDto } from './stock-history-entry.dto';

export class StockHistory {
    items: StockHistoryEntry[];
    total: number;

    constructor(response: ApiResponse<StockHistoryEntryDto[]>) {
        this.items = response.data.map((dto) => new StockHistoryEntry(dto));
        this.total = response.meta?.totalItems ?? 0;
    }
}
